import React from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Skeleton, Box } from '@mui/material';
import { Grid } from '@mui/material';

const SkeletonTable = () => {
  const rowCount = 9; // Number of skeleton rows
  const columnCount = 5; // Adjust based on your table's column count

  return (
    <TableContainer>
      <Table>
        <TableHead>
          <TableRow>
            {Array.from({ length: columnCount }).map((_, index) => (
              <TableCell key={index}>
                <Skeleton variant="text" width="50%" height={30} />
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <TableRow key={rowIndex}>
              {Array.from({ length: columnCount }).map((_, colIndex) => (
                <TableCell key={colIndex}>
                  {colIndex === 0 ? (
                    <Grid gap={2} display={'flex'} flexDirection={'row'} direction={'row'}>
                      <Skeleton variant="circular" width={40} height={40} />
                      <Skeleton variant="text" width={'50%'} height={40} />
                    </Grid>
                  ) : (
                    <Skeleton variant="text" width="80%" height={30} />
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SkeletonTable;
